import { Dispatch, MouseEvent, PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { GlobalState } from '../../../../../store/reducers';
import { getAttachment, getPrescription } from '../../../../../store/selectors/prescriptionPad';
import { Actions } from '../../../../../store/actions';
import { updateAttachment } from '../../../../../store/actions/prescriptionPad';
import AttachmentModal from '../AttachmentModal';
import { Attachment as PostAttachment } from '../../../../../api/sendAttachments';
import { Attachment } from '../../../../../store/types/prescription';
import AttachmentPatientHistory from './PatientAttachmentHistory';
import getPostsByPatientId from '../../../../../api/getPostsByPatientId';
import { Template } from '../../../../../api/getAttachmentTemplatesForDoctor';
import { MouseEventHandler } from 'react-select';
import { track } from '../../../../../tracking';

interface Props {
    dispatch: Dispatch<Actions>;
    attachment?: Attachment;
    patientId?: string;
    isAttachmentDialogVisible: boolean | undefined;
    onAttachmentVisibleChange: (visible: boolean) => void;
}

interface State {
    showAttachmentHistory?: boolean;
    postData?: Template[];
}

class AttachmentsPad extends PureComponent<Props, State> {
    state: State = {
        showAttachmentHistory: false,
        postData: [],
    };

    onSave = (attachment: Attachment, isTemplate?: boolean) => {
        const { dispatch } = this.props;
        track(
            attachment?.templateId
                ? 'TEMPLATE_SAVE_IN_PAD_SUCCESSFUL'
                : 'ATTACHMENT_SAVE_IN_PAD_SUCCESSFUL',
        );

        dispatch(
            updateAttachment({
                title: attachment?.title,
                description: attachment?.description,
                link: attachment?.link,
                file_type: attachment?.file_type,
                templateId: attachment?.templateId,
            }),
        );
    };

    onClear = (): void => {
        const { dispatch, onAttachmentVisibleChange } = this.props;
        dispatch(updateAttachment(undefined));
        onAttachmentVisibleChange(false);
        track('ATTACHMENT_CLEAR_FROM_PAD_SUCCESSFUL', { patient: this?.props?.patientId });
    };

    onClickAttachmentHistory = () => {
        const { onAttachmentVisibleChange } = this.props;
        getPostsByPatientId(this.props.patientId || '')
            .then((data) => {
                this.setState({ postData: data });
            })
            .catch((err) => {
                console.error(err);
            });

        this.setState({ showAttachmentHistory: true });
        onAttachmentVisibleChange(false);
        track('ATTACHMENT_HISTORY', { patient: this?.props?.patientId });
    };

    onClickAttachmentClose = () => {
        this.setState({ showAttachmentHistory: false });
    };

    render(): ReactNode {
        const {
            patientId,
            onAttachmentVisibleChange,
            isAttachmentDialogVisible,
            attachment,
        } = this.props;

        const { postData, showAttachmentHistory } = this.state;

        return (
            <>
                <AttachmentModal
                    patientId={patientId}
                    isVisible={isAttachmentDialogVisible}
                    onVisibleChange={(visible) => {
                        onAttachmentVisibleChange(visible);
                    }}
                    onSend={this.onSave}
                    templateApplyText="Apply"
                    title={attachment?.title}
                    description={attachment?.description}
                    link={attachment?.link}
                    file_type={attachment?.file_type}
                    onClear={this.onClear}
                    tabBarExtraContent={
                        <button
                            id="all-lab-tests-bt"
                            type="button"
                            className="ant-btn mb-8 flex items-center px-16 py-5 btn--small space-x-8 secondary-btn"
                            onClick={this.onClickAttachmentHistory}
                        >
                            <p className="text-14">Attachment History</p>
                            <div className="flex items-center justify-center w-16 h-16">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-15 h-15"
                                >
                                    <path
                                        d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                                        fill="#004BA8"
                                    ></path>
                                </svg>
                            </div>
                        </button>
                    }
                />

                {showAttachmentHistory && (
                    <AttachmentPatientHistory
                        postData={postData}
                        onClose={this.onClickAttachmentClose}
                    />
                )}
            </>
        );
    }
}

export default connect((state: GlobalState) => ({
    patientId: getPrescription(state)?.patient?.id,
    attachment: getAttachment(state),
}))(AttachmentsPad);
